var map = {
	"./glitter_1.jpg": "8057",
	"./glitter_10.jpg": "8d6e",
	"./glitter_11.jpg": "c18c",
	"./glitter_12.jpg": "cf86",
	"./glitter_13.jpg": "b87b",
	"./glitter_14.jpg": "ebf4",
	"./glitter_15.jpg": "8407",
	"./glitter_2.jpg": "b123",
	"./glitter_3.jpg": "f078",
	"./glitter_4.jpg": "6bd7",
	"./glitter_5.jpg": "29b7",
	"./glitter_6.jpg": "6f42",
	"./glitter_7.jpg": "7754",
	"./glitter_8.jpg": "8617",
	"./glitter_9.jpg": "c4a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5156";